<template>
  <form @submit.prevent="onSubmit" style="width: 100%;">
    <h3 class="is-size-3 has-text-centered m-b-5">{{$t('message.edit_dimension')}}</h3>
    <div class="columns">
      <div class="column">
        <field-input
          :value.sync="active.min_width"
          type="number"
          name="min_width"
          required
          :label="`${$t('form.min_width')}:`"
          :vvas="$t('form.min_width')"
          unit="mm"
        />
      </div>
      <div class="column">
        <field-input
          :value.sync="active.max_width"
          type="number"
          name="max_width"
          required
          :label="`${$t('form.max_width')}:`"
          :vvas="$t('form.max_width')"
          unit="mm"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <field-input
          :value.sync="active.min_height"
          type="number"
          name="min_height"
          required
          :label="`${$t('form.min_height')}:`"
          :vvas="$t('form.min_height')"
          unit="mm"
        />
      </div>
      <div class="column">
        <field-input
          :value.sync="active.max_height"
          type="number"
          name="max_height"
          required
          :label="`${$t('form.max_height')}:`"
          :vvas="$t('form.max_height')"
          unit="mm"
        />
      </div>
    </div>
    <field-input
      :value.sync="active.thickness"
      type="number"
      name="thickness"
      required
      :label="`${$t('form.thickness')}:`"
      :vvas="$t('form.thickness')"
      unit="mm"
    />

    <div class="field m-t-5">
      <div class="control is-clearfix">
        <button
          class="button is-primary is-pulled-right"
          :class="{ 'is-loading': formLoading }"
        >{{ $t("form.submit") }}</button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  async asyncData({ store, params, error, app }) {
    try {
      await store.dispatch("industries/setActiveIndustry", params.id);
      await store.dispatch("industries/setActiveGlassSize", params.size);
    } catch (e) {
      console.log(e);
      error(e);
    }
  },

  data() {
    return {
      id: this.$route.params.size,
      industry_id: this.$route.params.id,
      formLoading: false
    };
  },

  computed: {
    active() {
      return this.$store.state.industries.activeGlassSize;
    }
  },

  methods: {
    async onSubmit() {
      const validation = await this.$validator.validateAll();
      if (!validation) return;

      this.formLoading = true;

      const {
        id,
        industry_id,
        thickness,
        min_width,
        max_width,
        min_height,
        max_height
      } = this;

      try {
        const { data } = await this.$api.updateGlassDimension(this.active);

        this.$store.commit("industries/SET_GLASS_SIZES", {
          id: industry_id,
          data
        });

        this.$router.push(this.localePath("office-industries-id-glass-sizes"));
      } catch (e) {
        console.log(e);
        this.handleFormError(e.response.data);
      }

      this.formLoading = false;
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/nuxt/pages/office/industries/_id/glass-sizes/_size/edit.vue